import classNames from 'classnames'
import React, { Fragment } from 'react'
import { Icon } from 'react-spark'

import { sparkBaseClassName } from 'react-spark/src/util'

class NovaToggleHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isHovered: false
        };
    }

    getSizeClassName() {
        return sparkBaseClassName('TypeBodyTwo')
    }

    get className() {
        const {className} = this.props

        return classNames(
            this.getSizeClassName(),
            sparkBaseClassName('Link'),
            sparkBaseClassName('Link', null, 'plain'),
            sparkBaseClassName('Link', null, 'standalone'),
            {[className]: className}
        )
    }

    handleClick = (e) => {
        e.preventDefault();
        const { onToggle } = this.props;
        if (onToggle) {
            onToggle();
        }
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleClick(e);
        }
    }

    handleMouseEnter = () => {
        this.setState({ isHovered: true });
    }

    handleMouseLeave = () => {
        this.setState({ isHovered: false });
    }

    render = () => {
        const {children, className, iconPosition, size, isOpen, onToggle, ...props} = this.props

        const showBackground = size !== 'small' || (size === 'small' && this.state.isHovered);

        const iconWithBackground = (
            <div 
                style={{
                    backgroundColor: showBackground ? '#F2F2F3' : 'transparent',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'background-color 0.2s ease',
                    marginLeft: iconPosition === 'right' ? '8px' : '0',
                    marginRight: iconPosition === 'left' ? '8px' : '0',
                    marginTop: '-2px',
                    verticalAlign: 'middle'
                }}
            >
                <Icon
                    name='chevron-down'
                    style={{
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s ease',
                        width: '16px',
                        height: '16px',
                        strokeWidth: '8px',
                    }}
                />
            </div>
        )
        
        return (
            <a
                aria-expanded={isOpen ? 'true' : 'false'}
                className={this.className}
                data-sprk-toggle='trigger'
                onClick={this.handleClick}
                onKeyDown={this.handleKeyDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                {...props}
                style={{
                    ...props.style,
                    fontFamily: 'RocketSans-Medium',
                    color: this.state.isHovered ? '#de3341' : 'inherit'
                }}
            >
                {iconPosition === 'right' ? (
                    <Fragment>
                        {children}
                        {iconWithBackground}
                    </Fragment>
                ) : (
                    <Fragment>
                        {iconWithBackground}
                        {children}
                    </Fragment>
                )}
            </a>
        )
    }
}

export default NovaToggleHeader
